module.exports = __webpack_public_path__ + "assets/img/Print.2d6ada0c.png";